import { create } from 'zustand';

import { PickPropertiesOfType } from '@/types';

interface AuthModalState {
    isOpen: boolean;
    setIsOpen: (isOpen: this['isOpen']) => void;

    isAuthHidden: boolean;
    setIsAuthHidden: (isAuthHidden: this['isAuthHidden']) => void;

    showSignUp: boolean;
    setShowSignUp: (showSignUp: this['showSignUp']) => void;

    isBurgerMenuOpen: boolean;
    setIsBurgerMenuOpen: (isBurgerMenuOpen: this['isBurgerMenuOpen']) => void;

    isYooMoneyError: boolean;
    setIsYooMoneyError: (isYooMoneyErrorOpen: this['isYooMoneyError']) => void;

    isPurchaseErrorOpen: boolean;
    setIsPurchaseErrorOpen: (isPurchaseErrorOpen: this['isPurchaseErrorOpen']) => void;

    isPurchaseOpen: boolean;
    setIsPurchaseOpen: (isPurchaseOpen: this['isPurchaseOpen']) => void;

    isPurchaseSuccessOpen: boolean;
    setIsPurchaseSuccessOpen: (isPurchaseSuccessOpen: this['isPurchaseSuccessOpen']) => void;

    isWithdrawalOpen: boolean;
    setIsWithdrawalOpen: (isWithdrawalOpen: this['isWithdrawalOpen']) => void;

    isInviteOpen: boolean;
    setIsInviteOpen: (isInviteOpen: this['isWithdrawalOpen']) => void;

    isInviteSuccessOpen: boolean;
    setIsInviteSuccessOpen: (isInviteSuccessOpen: this['isInviteSuccessOpen']) => void;

    isCancelReservationOpen: boolean;
    setIsCancelReservationOpen: (isCancelReservation: this['isCancelReservationOpen']) => void;

    isReservationOpen: boolean;
    setIsReservationOpen: (isReservationOpen: this['isReservationOpen']) => void;

    isErrorOpen: boolean;
    setIsErrorOpen: (isErrorOpen: this['isErrorOpen']) => void;

    isProfileDeletionOpen: boolean;
    setIsProfileDeletionOpen: (isProfileDeletionOpen: this['isProfileDeletionOpen']) => void;

    hasOpenModals: () => boolean;
    closeAllModals: VoidFunction;
}

export const useModalStore = create<AuthModalState>()((set, get) => ({
    isOpen: false,
    setIsOpen: isOpen => set(() => ({ isOpen })),

    isAuthHidden: false,
    setIsAuthHidden: isAuthHidden => set(() => ({ isAuthHidden })),

    showSignUp: true,
    setShowSignUp: showSignUp => set(() => ({ showSignUp })),

    isBurgerMenuOpen: false,
    setIsBurgerMenuOpen: isBurgerMenuOpen => set(() => ({ isBurgerMenuOpen })),

    isPurchaseOpen: false,
    setIsPurchaseOpen: isPurchaseOpen => set(() => ({ isPurchaseOpen })),

    isYooMoneyError: false,
    setIsYooMoneyError: isYooMoneyErrorOpen =>
        set(() => ({ isYooMoneyError: isYooMoneyErrorOpen })),

    isPurchaseErrorOpen: false,
    setIsPurchaseErrorOpen: isPurchaseErrorOpen => set(() => ({ isPurchaseErrorOpen })),

    isPurchaseSuccessOpen: false,
    setIsPurchaseSuccessOpen: isPurchaseSuccessOpen => set(() => ({ isPurchaseSuccessOpen })),

    isWithdrawalOpen: false,
    setIsWithdrawalOpen: isWithdrawalOpen => set(() => ({ isWithdrawalOpen })),

    isInviteOpen: false,
    setIsInviteOpen: isInviteOpen => set(() => ({ isInviteOpen })),

    isInviteSuccessOpen: false,
    setIsInviteSuccessOpen: isInviteSuccessOpen => set(() => ({ isInviteSuccessOpen })),

    isCancelReservationOpen: false,
    setIsCancelReservationOpen: isCancelReservationOpen => set(() => ({ isCancelReservationOpen })),

    isReservationOpen: false,
    setIsReservationOpen: isReservationOpen => set(() => ({ isReservationOpen })),

    isErrorOpen: false,
    setIsErrorOpen: isErrorOpen => set(() => ({ isErrorOpen })),

    isProfileDeletionOpen: false,
    setIsProfileDeletionOpen: isProfileDeletionOpen => set(() => ({ isProfileDeletionOpen })),

    /**
     * Проверяет, есть ли хоть одно открытое модальное окно
     */
    hasOpenModals: () => {
        return Object.values(get()).some(value => typeof value === "boolean" && value);
    },

    closeAllModals: () =>
        set(state => {
            const closedModalStates: Partial<PickPropertiesOfType<AuthModalState, boolean>> = {};

            for (const key in state) {
                const modalStateKey = key as keyof typeof state;
                const modalState = state[modalStateKey];

                if (typeof modalState === 'boolean') {
                    closedModalStates[
                        modalStateKey as keyof PickPropertiesOfType<AuthModalState, boolean>
                    ] = false;
                }
            }

            return closedModalStates;
        }),
}));
